import { getImageUrl, ImageWidth } from '../../utils/imageUrl';

type Props = { imagePath?: string | null; alt?: string; size?: number };

/** Small square thumbnail shown beside a product or design-number name; renders nothing without an image. */
const ImageThumb = ({ imagePath, alt = '', size = 45 }: Props) =>
  imagePath ? (
    <img
      src={getImageUrl(imagePath, { width: ImageWidth.small })}
      alt={alt}
      className='rounded align-middle me-3'
      style={{ width: size, height: size, objectFit: 'cover' }}
      loading='lazy'
    />
  ) : null;

export { ImageThumb };
